import AppSerializer from 'serializers/app';

class CardSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}

	get attrs() {
		return {}
	}

	get relationships() {
		return {
			user: { serialize: 'id' },
		}
	}

}

export default CardSerializer;